export const clippingLayerDefinition = {
    geometryType: 'esriGeometryPolygon',
    objectIdField: 'uniqueId',
    extent: {
        xmin: 108.22364905699999,
        ymin: -36.98845284800001,
        xmax: 125.38457743000004,
        ymax: -20.765768271000013,
        spatialReference: {
            wkid: 7844,
            latestWkid: 7844
        }
    },
    fields: [
        {
            name: 'objectid',
            type: 'esriFieldTypeOID',
            alias: 'objectid',
            editable: false,
            nullable: false
        },
        {
            name: 'guid',
            type: 'esriFieldTypeString',
            alias: 'guid',
            editable: true,
            nullable: false,
            length: 50
        },
        {
            name: 'id',
            type: 'esriFieldTypeInteger',
            alias: 'id',
            editable: true,
            nullable: false
        },
        {
            name: 'type',
            type: 'esriFieldTypeInteger',
            alias: 'type',
            editable: true,
            nullable: true
        },
        {
            name: 'enlargementid',
            type: 'esriFieldTypeInteger',
            alias: 'enlargementid',
            editable: true,
            nullable: true
        }
    ]
};
